<template>
    <router-link :to="{ name: name }" class="menu-item relative block w-18 pt-2">
        <div v-if="isActive" class="absolute top-[-1px] right-0 left-0">
            <svg class="mx-auto" width="72" height="2" viewBox="0 0 72 2">
                <path d="M2 0H71.5L69.5 2H0L2 0Z" fill="url(#paint0_linear_18996_3609)" />
                <defs>
                    <linearGradient
                        id="paint0_linear_18996_3609"
                        x1="0"
                        y1="1"
                        x2="69.5"
                        y2="1"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#FF5656" />
                        <stop offset="1" stop-color="#FF2C2C" />
                    </linearGradient>
                </defs>
            </svg>
        </div>

        <div class="flex flex-col items-center justify-center text-center">
            <div class="h-8 w-8" :class="[isActive ? 'fill-red-600' : 'fill-white']">
                <slot></slot>
            </div>
            <h4
                :class="[isActive ? 'text-red-600' : 'text-white']"
                class="pt-1.5 font-sans text-[10px] leading-none font-bold tracking-tight"
            >
                {{ title }}
            </h4>
        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
    },
    computed: {
        currentRouteName() {
            return this.$route.meta?.navTab || this.$route.matched[0]?.name || ''
        },
        isActive() {
            return this.currentRouteName === this.name
        },
    },
}
</script>
